<template>
  <div class="registration">
    <Nav />
    <!-- <div class="header">
      <span><a href="/">{{ $t('register.header.title') }}</a></span>
    </div> -->
    <div class="container">
      <div class="container-warp">
        <div class="form-container">
          <h2 class="form-title">{{ $t('register.title') }}</h2>
          <el-form ref="formRef" :model="form" :rules="rules" label-position="top" class="registration-form">
            <!-- 参会方式 -->
            <el-form-item :label="$t('register.participation')" prop="participation" style="display: flex; flex-direction: column; align-items: flex-start;">
              <el-radio-group style="margin-top: 10px;" v-model="form.participation" class="radio-group">
                <el-radio value="in-person">{{ $t('register.inPerson') }}</el-radio>
                <el-radio value="online">{{ $t('register.online') }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 注册类型 -->
            <el-form-item :label="$t('register.registrationType')" prop="registrationType" style="display: flex; flex-direction: column; align-items: flex-start;">
              <el-radio-group style="margin-top: 10px;" v-model="form.registrationType" class="radio-group">
                <el-radio value="postgraduate">{{ $t('register.postgraduate') }}</el-radio>
                <el-radio value="undergraduate">{{ $t('register.undergraduate') }}</el-radio>
                <el-radio value="faculty">{{ $t('register.faculty') }}</el-radio>
                <el-radio value="regular_attendee">{{ $t('register.regular_attendee') }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 姓名 -->
            <el-form-item :label="$t('register.name')" class="name-form-item" required>
              <div class="name-input-container">
                <!-- 中文模式：姓在前，名在后 -->
                <template v-if="$i18n.locale === 'zh'">
                  <el-form-item prop="lastName" class="inline-form-item">
                    <el-input v-model="form.lastName" :placeholder="$t('register.lastNamePlaceholder')" class="form-input" />
                  </el-form-item>
                  <el-form-item prop="firstName" class="inline-form-item">
                    <el-input v-model="form.firstName" :placeholder="$t('register.firstNamePlaceholder')" class="form-input" />
                  </el-form-item>
                </template>
                <!-- 英文模式：名在前，姓在后 -->
                <template v-else>
                  <el-form-item prop="firstName" class="inline-form-item">
                    <el-input v-model="form.firstName" :placeholder="$t('register.firstNamePlaceholder')" class="form-input" />
                  </el-form-item>
                  <el-form-item prop="lastName" class="inline-form-item">
                    <el-input v-model="form.lastName" :placeholder="$t('register.lastNamePlaceholder')" class="form-input" />
                  </el-form-item>
                </template>
              </div>
            </el-form-item>
            
            <!-- ID Number/Passport Number -->
            <el-form-item 
              :label="$t('register.form.idNumber.label')" 
              prop="idNumber"
              :required="form.participation === 'in-person'"
            >
              <el-input 
                v-model="form.idNumber" 
                :placeholder="$t('register.form.idNumber.placeholder')"
                class="form-input" 
              />
            </el-form-item>
            
            <!-- 电子邮箱 -->
            <el-form-item :label="$t('register.email')" prop="email">
              <el-input v-model="form.email" type="email" :placeholder="$t('register.emailPlaceholder')"
                class="form-input" />
            </el-form-item>

            <!-- 联系电话 -->
            <el-form-item :label="$t('register.phone')" prop="phone" :required="form.participation === 'in-person'">
              <div class="phone-input-container">
                <vue3-country-intl v-model="form.countryCode" type="phone"
                  :placeholder="$t('register.countryCodePlaceholder')" class="country-selector" :showAreaCode="true"
                  :showLabelImg="true" :searchAble="true" />
                <el-input v-model="form.phoneNumber" :placeholder="$t('register.phoneNumberPlaceholder')"
                  class="phone-number-input" />
              </div>
            </el-form-item>

            <!-- 学校/公司 -->
            <el-form-item :label="$t('register.affiliation')" prop="affiliation">
              <el-input v-model="form.affiliation" :placeholder="$t('register.affiliationPlaceholder')"
                class="form-input" />
            </el-form-item>

            <!-- 职位 -->
            <el-form-item :label="$t('register.jobTitle')" prop="jobTitle">
              <el-input v-model="form.jobTitle" :placeholder="$t('register.jobTitlePlaceholder')" class="form-input" />
            </el-form-item>

            <!-- 国家 -->
            <el-form-item :label="$t('register.country')" prop="country">
              <el-input v-model="form.country" :placeholder="$t('register.countryPlaceholder')"
                class="form-input" />
            </el-form-item>

            <!-- 提交按钮 -->
            <el-form-item class="submit-section">
              <el-button type="primary" @click="submitForm" :loading="loading" class="submit-btn">
                {{ $t('register.submit') }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <Footer />
    
    <!-- 注册成功弹窗 -->
    <el-dialog
      v-model="showSuccessDialog"
      :show-close="false"
      :before-close="handleCloseDialog"
      class="success-dialog"
    >
      <div class="email-content" v-html="emailContent"></div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showSuccessDialog = false" type="primary">Close</el-button>
        </span>
      </template>
    </el-dialog>
    
    <!-- 固定在右下角的语言切换按钮 -->
    <!-- <div class="fixed-buttons">
      <div class="language-switcher">
        <button 
          @click="switchLanguage('zh')" 
          :class="{ active: currentLanguage === 'zh' }"
          class="lang-btn"
          :title="$t('common.chinese')"
        >
          中
        </button>
        <button 
          @click="switchLanguage('en')" 
          :class="{ active: currentLanguage === 'en' }"
          class="lang-btn"
          :title="$t('common.english')"
        >
          EN
        </button>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'

const i18n = useI18n()
const { t, locale } = i18n
const formRef = ref()
const loading = ref(false)
const currentLanguage = ref('zh')
const showSuccessDialog = ref(false)
const emailContent = ref('')

// 表单数据
const form = reactive({
  participation: '',
  registrationType: '',
  firstName: '',
  lastName: '',
  idNumber: '',
  jobTitle: '',
  countryCode: '+86', // 默认中国区号
  phoneNumber: '',
  phone: '', // 完整电话号码
  email: '',
  affiliation: '',
  country: ''
})

// 表单验证规则
const rules = {
  participation: [
    { required: true, message: t('register.validation.participationTypeRequired'), trigger: 'change' }
  ],
  registrationType: [
    { required: true, message: t('register.validation.registrationTypeRequired'), trigger: 'change' }
  ],
  firstName: [
    { required: true, message: t('register.validation.firstNameRequired'), trigger: 'blur' }
  ],
  lastName: [
    { required: true, message: t('register.validation.lastNameRequired'), trigger: 'blur' }
  ],
  idNumber: [
    {
      validator: (rule, value, callback) => {
        if (form.participation === 'in-person' && !value) {
          callback(new Error(t('register.validation.idNumberRequired')))
        // } else if (value && (value.length < 5 || value.length > 50)) {
        //   callback(new Error(t('register.validation.idNumberLength')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  jobTitle: [
    // 职位是可选的，不需要验证规则
  ],
  phone: [
    {
      validator: (rule, value, callback) => {
        // online参会时手机号为可选，in-person参会时手机号为必填
        if (form.participation === 'in-person') {
          if (!form.countryCode || !form.phoneNumber) {
            callback(new Error(t('register.validation.phoneRequired')))
          } else {
            callback()
          }
        } else {
          // online参会时完全可选，不进行任何验证
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  countryCode: [
    {
      validator: (rule, value, callback) => {
        // online参会时手机号为可选，in-person参会时手机号为必填
        if (form.participation === 'in-person') {
          if (!value) {
            callback(new Error(t('register.validation.countryCodeRequired')))
          } else {
            callback()
          }
        } else {
          // online参会时完全可选，不进行任何验证
          callback()
        }
      },
      trigger: 'change'
    }
  ],
  phoneNumber: [
    {
      validator: (rule, value, callback) => {
        // online参会时手机号为可选，in-person参会时手机号为必填
        if (form.participation === 'in-person') {
          if (!value) {
            callback(new Error(t('register.validation.phoneNumberRequired')))
          } else {
            callback()
          }
        } else {
          // online参会时完全可选，不进行任何验证
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  email: [
    { required: true, message: t('register.validation.emailRequired'), trigger: 'blur' },
    { type: 'email', message: t('register.validation.emailInvalid'), trigger: 'blur' }
  ],
  affiliation: [
    { required: true, message: t('register.validation.affiliationRequired'), trigger: 'blur' }
  ],
  country: [
    { required: true, message: t('register.validation.countryRequired'), trigger: 'blur' }
  ]
}

// 提交表单
const submitForm = async () => {
  if (!formRef.value) return

  try {
    const valid = await formRef.value.validate()
    if (valid) {
      loading.value = true

      // 构建完整电话号码
      let fullPhone = null
      if (form.phoneNumber && form.countryCode) {
        fullPhone = form.phoneNumber.startsWith('+') ? form.phoneNumber : form.countryCode + form.phoneNumber
      }

      // 使用API模块提交表单
      const response = await import('@/api/registration')
        .then(module => module.createRegistration({
          participation_type: form.participation === 'in-person' ? 'offline' : 'online',
          registration_type: form.registrationType,
          first_name: form.firstName,
          last_name: form.lastName,
          id_number: form.idNumber || null,
          job_title: form.jobTitle || null,
          phone: fullPhone,
          email: form.email,
          affiliation: form.affiliation,
          country: form.country,
          language: localStorage.getItem('locale') || 'zh'
        }))

      if (response.success) {
        // 显示邮件内容弹窗
        emailContent.value = getEmailContent()
        showSuccessDialog.value = true
        // 重置表单
        formRef.value.resetFields()
      } else {
        // 处理特定错误消息
        if (response.message.includes('邮箱已注册')) {
          ElMessage({
            message: t('messages.emailExists'),
            type: 'warning',
            duration: 5000,
            showClose: true
          })
        } else if (response.message.includes('电话号码已注册')) {
          ElMessage({
            message: t('messages.phoneExists'),
            type: 'warning',
            duration: 5000,
            showClose: true
          })
        } else {
          ElMessage.error(response.message || t('register.submitError'))
        }
      }
    }
  } catch (error) {
    console.error('Submit error:', error)
    // 检查错误信息中是否包含邮箱或电话号码重复的提示
    if (error.response && error.response.data && error.response.data.message) {
      const errorMessage = error.response.data.message
      if (errorMessage.includes('邮箱已注册')) {
        ElMessage({
          message: t('messages.emailExists'),
          type: 'warning',
          duration: 5000,
          showClose: true
        })
      } else if (errorMessage.includes('电话号码已注册')) {
        ElMessage({
          message: t('messages.phoneExists'),
          type: 'warning',
          duration: 5000,
          showClose: true
        })
      } else {
        ElMessage.error(t('register.submitError'))
      }
    } else {
      ElMessage.error(t('register.submitError'))
    }
  } finally {
    loading.value = false
  }
}

// 监听电话号码变化，自动更新完整电话号码
watch(
  () => [form.countryCode, form.phoneNumber],
  ([countryCode, phoneNumber]) => {
    if (countryCode && phoneNumber) {
      form.phone = phoneNumber.startsWith('+') ? phoneNumber : countryCode + phoneNumber
    } else {
      form.phone = ''
    }
  },
  { immediate: true }
)

// 获取邮件内容
const getEmailContent = () => {
  return `
    <div style="font-family: 'Times New Roman', serif; line-height: 1.6; margin: 0; padding: 0px; color: #333;">
      <div style="max-width: 700px; margin: 0 auto; padding: 0;">
        <div style="text-align: center; margin-bottom: 30px;">
          <h1 style="color: #2c3e50; font-size: 30px; margin-bottom: 10px;">Registered Successfully</h1>
        </div>
        
        <div style="background-color: #fff; padding: 10px; border: 1px solid #ddd;">
          <p>Dear participants,</p>
          
          <p>Thank you for registering <strong>"The 7th International Conference on Aging and Cancer"</strong>. Your registration application has been accepted.</p>
          
          <div style="margin-bottom: 25px;">
            <p><strong>Important information for the On-site participation:</strong></p>
            <p><strong>Date:</strong>November 21st, 2025 - November 22nd, 2025</p>
            <p><strong>Venue:</strong>LIYAN Hall, Hainan Medical University (No. 3 Xueyuan Road, Longhua District, Haikou, Hainan, China)</p>
            
            <div style="background-color: #f8f9fa; padding: 15px; border-left: 4px solid #3498db; margin: 15px 0;">
              <p>• Two free buffet lunches are offered on November 21st - 22nd, 2025, other accommodations and flight tickets are at your own expense.</p>
              <p>• The number of participants for the On-Site Conference is limited to 300 seats, FCFS.</p>
            </div>
          </div>
          
          <div style="text-align: center; margin: 30px 0;">
            <h3 style="color: #34495e; font-size: 18px; margin-bottom: 10px;">Scan the QR Code or Click the Link for Online Participation</h3>
            <p><a href="https://nlfghu.vzb.whymjzkj3.com.cn/v3/course/alive/472578197?v=1756210002029" style="color: #3498db; text-decoration: none;">The 7th International Conference on Aging and Cancer</a></p>
            <img src="http://test1.yiduan.top/api/uploads/email_qrcode.png" alt="QR Code" style="width: 200px; height: 200px; margin: 10px 0;">
          </div>
          
          <p>For those who cannot participate on November 21st to 22nd, 2025, the whole conference will be recorded, and you can watch it later at <a href="https://nlfghu.vzb.whymjzkj3.com.cn/v3/course/alive/472578197?v=1756210002029" style="color: #3498db; text-decoration: none;">"The 7th International Conference on Aging and Cancer"</a>.</p>
          
          <p>The recorded videos will be also available at: <a href="http://www.icacconference.cn/2025" style="color: #3498db; text-decoration: none;">http://www.icacconference.cn/2025/</a> after the November 28th, 2025.</p>
          
          <p>If you have any questions, please don't hesitate to reach us.</p>
          <p>We look forward to meeting you on-site or online.</p>
          <p>Thank you.</p>
        </div>
        
        <div style="margin-top: 30px; text-align: center; font-style: italic; color: #666;">
          <p>ICAC Secretary / Organizing Team of the 7th International Conference on Aging and Cancer</p>
        </div>
      </div>
    </div>
  `
}

// 关闭弹窗处理
const handleCloseDialog = (done) => {
  done()
}

// 语言切换功能
const switchLanguage = (lang) => {
  locale.value = lang
  currentLanguage.value = lang
  localStorage.setItem('language', lang)
  localStorage.setItem('locale', lang)
  document.title = t('register.page.title')
}

onMounted(() => {
  // 从localStorage恢复语言设置
  // const savedLang = localStorage.getItem('language') || localStorage.getItem('locale') || 'zh'
  // currentLanguage.value = savedLang
  // locale.value = savedLang

  localStorage.setItem('language', 'en')
  locale.value = 'en'

  // emailContent.value = getEmailContent()


  document.title = t('register.page.title')
})
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  height: 80px;
  display: flex;
  background-color: #ffffff;
  box-shadow: 0px 0px 7px 0px rgba(6, 0, 1, 0.11);
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;

  a {
    text-decoration: none;
    font-size: 18px;
    color: #333;

    &:hover {
      color: #62a8ea
    }
  }
}

.container {
  min-height: calc(100vh - 160px);
  padding: 20px 20px;

  .container-warp {
    max-width: 1200px;
    margin: 0 auto;

    .form-container {

      .form-title {
        background: linear-gradient(180deg, #fff, #f4f4f4);
        border-radius: 5px 5px 0 0;
        border: 1px solid #e3e3e3;
        position: relative;
        padding: 10px 0;
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 300;
        letter-spacing: 2px;
        text-align: center;
        color: #666;
      }

      .registration-form {
        .el-form-item {
          margin-bottom: 24px;
          display: flex;
          align-items: center;

          :deep(.el-form-item__label) {
            font-weight: 500;
            width: 180px;
            color: #333;
            font-size: 16px;
            margin-bottom: 0px;
          }

          :deep(.el-form-item__content) {
            line-height: normal;
          }

          .radio-group {
            display: flex;
            flex-wrap: wrap;
            gap: 35px;

            :deep(.el-radio) {
              margin-right: 0;

              .el-radio__label {
                font-size: 14px;
                color: #666;
              }

              &.is-checked {
                .el-radio__label {
                  color: #409eff;
                }
              }
            }
          }

          .form-input {
            :deep(.el-input__wrapper) {
              border-radius: 5px;
              border: 1px solid #e8e8e8;
              transition: border-color 0.3s;
              box-shadow: none;

              &:hover {
                border-color: #c0c4cc;
              }

              &.is-focus {
                border-color: #409eff;
                box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
              }
            }

            :deep(.el-input__inner) {
              font-size: 14px;
              padding: 12px 10;
              height: 36px;
            }
          }

          // 姓名输入容器样式
          &.name-form-item {
            :deep(.el-form-item__content) {
              .name-input-container {
                display: flex;
                gap: 2px;
                align-items: flex-start;

                .inline-form-item {
                  flex: 1;
                  margin-bottom: 0;

                  :deep(.el-form-item__content) {
                    margin-left: 0 !important;
                  }
                }
              }
            }
          }

          // 电话号码输入容器样式
          .phone-input-container {
            display: flex;
            gap: 2px;
            align-items: center;

            :deep(.vue-country-intl-inputer) {
              :deep(.country-country-intl-input) {
                border-radius: 4px !important;
                border: 1px solid #dcdfe6 !important;
                transition: border-color 0.3s;
                font-size: 14px;
                padding: 12px 15px;
                height: 40px;

                &:hover {
                  border-color: #c0c4cc;
                }

                &:focus {
                  border-color: #409eff;
                  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  outline: none;
                }
              }

              .country-intl__dropdown {
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
              }

            }

            .phone-number-input {
              flex: 1;

              :deep(.el-input__wrapper) {
                border-radius: 5px;
                border: 1px solid #e8e8e8;
                transition: border-color 0.3s;
                box-shadow: none;

                &:hover {
                  border-color: #c0c4cc;
                }

                &.is-focus {
                  border-color: #409eff;
                  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                }
              }

              :deep(.el-input__inner) {
                font-size: 14px;
                padding: 12px 15px;
                height: 36px;
              }
            }
          }

          &.submit-section {
            margin-top: 32px;
            text-align: center;

            :deep(.el-form-item__content) {
              display: flex;
              justify-content: center;
            }

            .submit-btn {
              min-width: 130px;
              height: 44px;
              font-size: 16px;
              font-weight: 500;
              border-radius: 4px;
              border: none;
              transition: all 0.3s;
              background-color: #2aa2d1;

              &:hover {
                background-color: #2aaadc;
              }

              &:active {
                transform: translateY(0);
              }
            }
          }
        }
      }
    }
  }
}


// 响应式设计
@media (max-width: 768px) {
  .container {
    padding: 15px 15px;

    .container-warp {
      .form-container {
        padding: 24px 20px;

        .form-title {
          font-size: 20px;
          margin-bottom: 24px;
        }

        .registration-form {
          .el-form-item {
            margin-bottom: 20px;
            flex-direction: column;
            align-items: flex-start;

            :deep(.el-form-item__label) {
              margin-bottom: 10px;
            }

            :deep(.el-form-item__content) {
              width: 100%;

              .el-form-item__error {
                font-size: 10px;
              }
            }

            .radio-group {
              flex-direction: row;
              gap: 8px;
              margin-top: 0 !important;
            }

            // 姓名输入容器移动端样式
            &.name-form-item {
              :deep(.el-form-item__content) {
                .name-input-container {
                  flex-direction: row;
                  gap: 2px;

                  .inline-form-item {
                    width: 100%;
                  }
                }
              }
            }

            // 电话号码输入容器移动端样式
            .phone-input-container {
              flex-direction: column;
              gap: 2px;
              
              :deep(.vue-country-intl-inputer) {
                width: 100%;
                max-width: 100%;
              }
              
              .phone-number-input {
                width: 100%;
              }
            }

            &.submit-section {
              margin-top: 24px;

              .submit-btn {
                width: 100%;
                // max-width: 280px;
              }
            }
          }
        }
      }
    }
  }
}

// 固定按钮组
.fixed-buttons {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 语言切换按钮
.language-switcher {
  display: flex;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 25px;
  padding: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.lang-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  color: #666;
  cursor: pointer;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  
  &:hover {
    background-color: rgba(52, 152, 219, 0.1);
    color: #3498db;
  }
  
  &:focus {
    outline: none;
  }
  
  &.active {
    background-color: #3498db;
    color: white;
    box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
  }
}

// 响应式设计 - 语言切换按钮
@media (max-width: 768px) {
  .fixed-buttons {
    bottom: 20px;
    right: 20px;
    gap: 10px;
  }
  
  .lang-btn {
    width: 35px;
    height: 35px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .fixed-buttons {
    bottom: 45px;
    right: 25px;
  }
  
  .lang-btn {
    width: 30px;
    height: 30px;
    font-size: 11px;
  }
}

// 注册成功弹窗样式
:deep(.success-dialog) {
  .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }
  
  .el-dialog__header {
    display: none;
    background-color: #f8f9fa;
    padding: 20px 24px;
    border-bottom: 1px solid #e9ecef;
    
    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
    }
  }
  
  .el-dialog__body {
    padding: 0;
    // max-height: 70vh;
    overflow-y: auto;
    
    .email-content {
      padding: 0;
      
      // 重置邮件内容样式
      h1, h2, h3 {
        margin-top: 0;
      }
      
      p {
        margin-bottom: 12px;
      }
      
      a {
        color: #3498db;
        text-decoration: none;
        
        &:hover {
          text-decoration: underline;
        }
      }
      
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
  
  .el-dialog__footer {
    padding: 16px 24px;
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;
    text-align: center;
    
    .el-button {
      min-width: 100px;
    }
  }
}

// 移动端弹窗样式
@media (max-width: 768px) {
  :deep(.success-dialog) {
      width: 95% !important;
      margin: 5vh auto;
    
    .el-dialog__body {
      max-height: 70vh;
      
      .email-content {
        font-size: 14px;
        
        h1 {
          font-size: 18px !important;
        }
        
        h3 {
          font-size: 16px !important;
        }
        
        img {
          width: 150px !important;
          height: 150px !important;
        }
      }
    }
  }
}
</style>
